module.exports = __webpack_public_path__ + "img/thank_2021_tip4_mall.d6470af7.png";